import styled from "styled-components";

export const ActionDisplay = styled.div`
  margin-top: auto;
`;



// WEBPACK FOOTER //
// ./src/components/QuizBox/ActionDisplay.tsx